import { Flex, Tooltip, Typography } from "antd";
import { ColumnType } from "antd/es/table";
import {
  DIRECTION_TEXT,
  CONTRACT_STATUSES,
  ContractGridDto,
  getEnumKeys,
  CONTRACT_STATUS_ENUM,
  CONTRACT_STATUS_FILTERS_PENDING_PAGE_TEXTS,
} from "interfaces";
import { ContractList } from "stores/ContractList";
import { UserStore } from "stores/UserStore";
import { Status, CurrencyFlagRound, DirectionIcon } from "ui";
import { dateFormat, formatWithDecimals, getFilterIcon, getSortIcon } from "utils";
import styles from "./contracts.module.css";
import amountStyles from "ui/DisplayAmount/DisplayAmount.module.css";
import { ProgressBar } from "ui/ProgressBar";

export const getColumns = (contracts?: ContractList) => {
  return [
    {
      dataIndex: "direction",
      key: "direction",
      title: "Тип",
      width: 60,
      render: (_: any, record: ContractGridDto) => {
        return <DirectionIcon direction={record.direction} />;
      },
    },
    {
      dataIndex: "unk",
      key: "unk",
      title: "УНК договора",
      width: 200,
      render: (_: any, record: ContractGridDto) => {
        const direction = record.direction;
        return (
          <Flex gap="small">
            <div className={styles.textContainer}>
              <Typography.Text>{record.unk}</Typography.Text>
              <Typography.Text type="secondary">{DIRECTION_TEXT[direction]}</Typography.Text>
            </div>
          </Flex>
        );
      },
    },
    {
      dataIndex: "companyName",
      key: "companyName",
      title: "Компания",
      width: 350,
      className: `text-clamp-ellipsis`,
      render: (companyName: string) => {
        return (
          <Tooltip trigger="hover" placement="topLeft" title={companyName}>
            <Typography.Text>{companyName}</Typography.Text>
          </Tooltip>
        );
      },
    },
    {
      dataIndex: "fiat.fiatAmount",
      key: "fiatAmount",
      title: "Сумма оплачено / всего",
      sortable: true,
      sorter: (a: ContractGridDto, b: ContractGridDto) => a.fiatAmount - b.fiatAmount,
      sortIcon: getSortIcon,
      width: 400,
      render: (_: any, record: ContractGridDto) => {
        return record.fiatAmount === 0 ? (
          <Flex vertical gap="small" justify="end">
            <div className={amountStyles.amountContainer}>
              <CurrencyFlagRound currency={record.fiatCurrency} />
              <Typography.Text>
                {`${formatWithDecimals(record.paidAmount)}${String.fromCharCode(8201)}${record.fiatCurrency}`} /
                Рамочный{" "}
              </Typography.Text>
            </div>
          </Flex>
        ) : (
          <Flex vertical gap="small" justify="end">
            <div className={amountStyles.amountContainer}>
              <CurrencyFlagRound currency={record.fiatCurrency} />
              <Typography.Text>
                {`${formatWithDecimals(record.paidAmount, 0)}${String.fromCharCode(8201)}/ ${formatWithDecimals(
                  record.fiatAmount,
                  0
                )}${String.fromCharCode(8201)}${record.fiatCurrency}`}
              </Typography.Text>
            </div>
            <ProgressBar
              percent={(record.paidAmount / record.fiatAmount) * 100}
              className={styles.progressBarContainer}
            />
          </Flex>
        );
      },
    },
    {
      dataIndex: "status",
      key: "statuses",
      title: "Статус",
      align: "right",
      sortable: true,
      sorter: (a: ContractGridDto, b: ContractGridDto) => a.statusDate.localeCompare(b.statusDate),
      sortIcon: getSortIcon,

      width: 110,
      render: (_: any, record: ContractGridDto) => {
        const { status, statusDate } = record;
        return (
          <Status
            color={CONTRACT_STATUSES.colors[status]}
            children={CONTRACT_STATUSES.texts[status]}
            date={dateFormat(statusDate, true)}
          />
        );
      },
    },
  ].filter((c) => !!c) as ColumnType<ContractGridDto>[];
};
